import React, { Component } from "react";
import {
  Paper,
  TextField,
  DropDownMenu,
  MenuItem,
  Subheader,
  Divider,
  FlatButton,
  AutoComplete,
  ListItem,
} from "material-ui";
import Formsy from "formsy-react";
import {
  FormsyText,
  FormsyAutoComplete,
  FormsyRadioGroup,
  FormsyRadio,
  FormsySelect,
} from "formsy-material-ui/lib";
import Loading from "../Loading";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import SelectableList from "../SelectableList";

class StampsLabelForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: [],
      rates: [],
      labelQueue: [],
      cleansedAddress: {},
      account: {},
      shipDate: "",
      serviceTypes: {
        "US-FC": "First-Class Mail",
        "US-PP": "Parcel Post",
        "US-PM": "Priority Mail",
        "US-XM": "Priority Mail Express",
        "US-LM": "Media Mail",
        "US-MM": "Library Mail",
        "US-PS": "Parcel Select Ground",
        "US-EMI": "Priority Mail Express International",
        "US-PMI": "Priority Mail International",
        "US-FCI": "First-Class Mail International",
      },
    };

    this.cleanseAddress = this.cleanseAddress.bind(this);
    this.renderShippingAddress = this.renderShippingAddress.bind(this);
    this.renderRates = this.renderRates.bind(this);
    this.renderRateSelections = this.renderRateSelections.bind(this);
    this.getRates = this.getRates.bind(this);
    this.createIncindium = this.createIncindium.bind(this);
    this.formatServiceName = this.formatServiceName.bind(this);
    this.renderLabelQueue = this.renderLabelQueue.bind(this);
    this.labelPreview = this.labelPreview.bind(this);
  }

  componentDidMount() {
    let url = `/api/clients`;
    let options = {
      headers: {
        token: this.props.token.jwt,
      },
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        if (json.length > 0) {
          let clients = json.map((client, i) => {
            let name = `${client.name} | (${client.uid__c})`;
            return { id: client.id, name: name, client: client };
          });
          this.setState({ dataSource: clients });
        }
      });

    this.props.authFetchDetails("stamps/getAccountInfo", this.props.token.jwt);

    let d = new Date();
    let month =
      d.getMonth() + 1 < 10 ? `0${d.getMonth() + 1}` : d.getMonth() + 1;
    let shipDate = `${d.getFullYear()}-${month}-${d.getDate()}-05:00`;
    // console.log(shipDate);

    this.setState({ shipDate });
  }

  submitForm(data) {
    alert(JSON.stringify(data, null, 4));
  }

  notifyFormError(data) {
    console.error("Form error:", data);
  }

  cleanseAddress() {
    if (this.refs.form.getModel().account) {
      let name = this.refs.form.getModel().account;
      let accounts = this.state.dataSource;
      let client;
      for (let i in accounts) {
        if (accounts[i].name === name) client = accounts[i].client;
      }
      if (client) {
        let body = {
          Address1: client.billingstreet,
          City: client.billingcity,
          State: client.billingstate,
          FullName: client.name,
          ZIPCode: client.billingpostalcode,
        };
        let url = `/api/stamps/cleanseAddress`;
        let options = {
          method: "post",
          headers: {
            token: this.props.token.jwt,
            Accept: "Application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        };
        fetch(url, options)
          .then((res) => res.json())
          .then((json) => {
            this.setState({ cleansedAddress: json });
          });
      }
    }
  }

  getRates() {
    let form = this.refs.form.getModel();
    if (this.state.cleansedAddress.Address && form.packageType !== "") {
      let body = {
        FromZIPCode: this.props.details.AccountInfo.LPOZip,
        ToZIPCode: this.state.cleansedAddress.Address.ZIPCode,
        PackageType: form.packageType,
        ShipDate: this.state.shipDate,
      };
      if (form.weightLb) body.WeightLb = form.weightLb;
      if (form.weightOz) body.WeightOz = form.weightOz;

      let url = `/api/stamps/getRates`;
      let options = {
        method: "post",
        headers: {
          token: this.props.token.jwt,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      };
      fetch(url, options)
        .then((res) => res.json())
        .then((json) => {
          this.setState({ rates: json.Rates.Rate });
        });
    }
  }

  createIncindium() {
    let { rateSelection, weightLb, weightOz } = this.refs.form.getModel();
    let toAddress = this.state.cleansedAddress.Address;
    let To = {
      FullName: toAddress.FullName,
      Address1: toAddress.Address1,
      City: toAddress.City,
      State: toAddress.State,
      ZIPCode: toAddress.ZIPCode,
    };
    let Rate = {
      FromZIPCode: rateSelection.FromZIPCode,
      ToZIPCode: rateSelection.ToZIPCode,
      Amount: rateSelection.Amount,
      ServiceType: rateSelection.ServiceType,
      PackageType: rateSelection.PackageType,
      ShipDate: rateSelection.ShipDate.split("T")[0],
    };
    if (weightLb) Rate.WeightLb = weightLb;
    if (weightOz) Rate.WeightOz = weightOz;
    // Rate.DeliveryDate = Rate.DeliveryDate.slice(0, 10);
    // Rate.ShipDate = this.state.shipDate.slice(0, 10);
    console.log(To, Rate);
    let url = "/api/stamps/createIndicium?isDev=true";
    let options = {
      method: "post",
      headers: {
        token: this.props.token.jwt,
        "content-type": "application/json",
      },
      body: JSON.stringify({ To, Rate }),
    };
    fetch(url, options)
      .then((res) => res.json())
      .then((json) => {
        console.log(json);
        let labelQueue = this.state.labelQueue;
        labelQueue.push(json);
        this.setState({ labelQueue: labelQueue });
        // this.props.downloadLabel(json.URL);
      });
  }

  formatServiceName(cell, row) {
    let { serviceTypes } = this.state;
    return serviceTypes[row.ServiceType];
  }

  renderRates() {
    if (this.state.rates.length > 0) {
      let filter = { type: "TextFilter", delay: 500 };
      return (
        <BootstrapTable ref="table" data={this.state.rates} pagination>
          <TableHeaderColumn
            dataField="ServiceType"
            filter={filter}
            dataSort
            isKey
          >
            Service Type
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="ServiceName"
            dataSort
            filter={filter}
            dataFormat={this.formatServiceName}
          >
            Service Name
          </TableHeaderColumn>
          <TableHeaderColumn dataField="Amount" dataSort filter={filter}>
            Amount
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="DeliverDays"
            dataSort
            filter={filter}
            width="200"
          >
            Deliver Days
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="PackageType"
            dataSort
            filter={filter}
            width="200"
          >
            Package Type
          </TableHeaderColumn>
        </BootstrapTable>
      );
    }
  }

  renderShippingAddress() {
    if (this.state.cleansedAddress.Address) {
      let address = this.state.cleansedAddress.Address;
      return (
        <div className="container">
          <p>FullName: {address.FullName}</p>
          <p>Address1: {address.Address1}</p>
          <p>City: {address.City}</p>
          <p>State: {address.State}</p>
          <p>ZIPCode: {address.ZIPCode}</p>
        </div>
      );
    }
  }

  renderAccountInfo() {
    if (this.props.details.AccountInfo) {
      let account = this.props.details.AccountInfo;
      return (
        <div className="container">
          <p>Username: {account.Username}</p>
          <p>Available Balance: {account.PostageBalance.AvailablePostage}</p>
          <p>State: {account.LPOState}</p>
          <p>City: {account.LPOCity}</p>
          <p>Zip: {account.LPOZip}</p>
          <p>CustomerID: {account.CustomerID}</p>
          <p>UserID: {account.UserID}</p>
        </div>
      );
    }
  }

  renderRateSelections() {
    if (this.state.rates.length > 0) {
      let selections = [];
      let { rates, serviceTypes } = this.state;
      rates.map((rate, i) => {
        selections.push(
          <MenuItem
            key={i}
            value={rate}
            primaryText={`${rate.ServiceType} - ${serviceTypes[rate.ServiceType]} - ${rate.PackageType}`}
          />,
        );
      });
      return selections;
    }
  }

  renderLabelQueue() {
    if (this.state.labelQueue.length > 0) {
      let labels = this.state.labelQueue;
      let rows = [];
      labels.map((label, i) => {
        rows.push(
          <ListItem
            onClick={this.labelPreview.bind(this, i)}
            key={i}
            value={label}
            primaryText={`${label.To.FullName}`}
          />,
        );
      });
      return rows;
    } else {
      return <ListItem primaryText={"No Labels Queued"} disabled={true} />;
    }
  }

  labelPreview(i) {
    let label = this.state.labelQueue[i];
    let title = `${label.To.FullName}`;

    let content = [
      <div>
        <img src={`${label.URL}`} alt="Label Image Error" />
        <p>{JSON.stringify(label.To, null, 4)}</p>
        <p>{JSON.stringify(label, null, 4)}</p>
      </div>,
    ];

    let actions = [
      <FlatButton
        key="ok"
        label="Ok"
        onClick={this.props.closeDialog.bind(this)}
      />,
    ];

    this.props.openDialog(title, content, actions);
  }

  render() {
    let address = this.state.cleansedAddress.Address;

    if (this.props.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.appbar.color} />
          </center>
        </div>
      );
    } else {
      return (
        <div className="container">
          <Paper
            className="container"
            zDepth={2}
            style={{
              marginTop: "2em",
              paddingTop: "1em",
              paddingBottom: "1em",
            }}
          >
            <Subheader>Label Queue</Subheader>
            <Divider />
            <div>
              <SelectableList defaultValue={-1}>
                {this.renderLabelQueue()}
              </SelectableList>
            </div>
          </Paper>
          <Paper
            className="container"
            zDepth={2}
            style={{
              marginTop: "2em",
              paddingTop: "1em",
              paddingBottom: "1em",
            }}
          >
            <Formsy.Form
              ref="form"
              onValidSubmit={this.submitForm}
              onInvalidSubmit={this.notifyFormError}
            >
              <div className="col-sm-6">
                <FormsyAutoComplete
                  required
                  fullWidth
                  name="account"
                  floatingLabelText="Account"
                  filter={AutoComplete.caseInsensitiveFilter}
                  maxSearchResults={15}
                  dataSource={this.state.dataSource}
                  dataSourceConfig={{ text: "name", value: "id" }}
                />
                <br />
                <FormsyText
                  required
                  fullWidth
                  name="weightLb"
                  floatingLabelText="Weight (lb)"
                />
                <Subheader>Print Options</Subheader>
                <FormsyRadioGroup
                  required
                  fullWidth
                  name="printOptions"
                  valueSelected={this.state.printOptions}
                  onChange={this.handleSelection}
                >
                  <FormsyRadio value="top" label="Top" />
                  <FormsyRadio value="bottom" label="Bottom" />
                </FormsyRadioGroup>
                <br />
              </div>
              <div className="col-sm-6">
                <FormsySelect
                  required
                  fullWidth
                  name="packageType"
                  floatingLabelText="Package Type"
                >
                  <MenuItem value={""} primaryText="" />
                  <MenuItem value={"Letter"} primaryText="Letter" />
                  <MenuItem
                    value={"Large Envelope or Flat"}
                    primaryText="Large Envelope or Flat"
                  />
                  <MenuItem
                    value={"Thick Envelope"}
                    primaryText="Thick Envelope"
                  />
                  <MenuItem value={"Package"} primaryText="Package" />
                  <MenuItem
                    value={"Flat Rate Box"}
                    primaryText="Flat Rate Box"
                  />
                  <MenuItem
                    value={"Small Flat Rate Box"}
                    primaryText="Small Flat Rate Box"
                  />
                  <MenuItem
                    value={"Large Flat Rate Box"}
                    primaryText="Large Flat Rate Box"
                  />
                  <MenuItem
                    value={"Flat Rate Envelope"}
                    primaryText="Flat Rate Envelope"
                  />
                  <MenuItem
                    value={"Large Package"}
                    primaryText="Large Package"
                  />
                  <MenuItem
                    value={"Oversize Package"}
                    primaryText="Oversize Package"
                  />
                  <MenuItem
                    value={"Regional Rate Box A"}
                    primaryText="Regional Rate Box A"
                  />
                  <MenuItem
                    value={"Regional Rate Box B"}
                    primaryText="Regional Rate Box B"
                  />
                  <MenuItem
                    value={"Legal Flat Rate Envelope"}
                    primaryText="Legal Flat Rate Envelope"
                  />
                  <MenuItem
                    value={"Regional Rate Box C"}
                    primaryText="Regional Rate Box C"
                  />
                </FormsySelect>
                <br />
                <FormsyText
                  required
                  fullWidth
                  name="weightOz"
                  floatingLabelText="Weight (oz)"
                />
                <FormsySelect
                  required
                  fullWidth
                  name="rateSelection"
                  floatingLabelText="Rates"
                >
                  <MenuItem value="" primaryText="" />
                  {this.renderRateSelections()}
                </FormsySelect>
              </div>
            </Formsy.Form>
            <div className="col-sm-12">
              <Divider />
              <Subheader>Rates</Subheader>
              {this.renderRates()}
            </div>
            <div className="col-sm-12">
              <Divider />
              <Subheader>Shipping Address</Subheader>
              {this.renderShippingAddress()}
            </div>
            <div className="col-sm-12">
              <Divider />
              <Subheader>Account Info</Subheader>
              {this.renderAccountInfo()}
            </div>
            <div className="col-sm-12">
              <Divider />
              <br />
              <center>
                <FlatButton
                  hoverColor="#9E9E9E"
                  label="Get Rates"
                  onClick={this.getRates}
                />
                <FlatButton
                  hoverColor="#9E9E9E"
                  label="Get Label"
                  onClick={this.createIncindium}
                />
                <FlatButton
                  hoverColor="#9E9E9E"
                  label="Cleanse Address"
                  onClick={this.cleanseAddress}
                />
              </center>
            </div>
          </Paper>
        </div>
      );
    }
  }
}

export default StampsLabelForm;



// WEBPACK FOOTER //
// ./app/components/Stamps/StampsLabelForm.js